export default {
  namespaced: true,
  custom_forms: {
    select_tenant: "Selecciona un tenant",
    select_users: "Selecciona usuarios",
    select_user_group: "Selecciona grupos de usuarios",
    select_facility: "Selecciona una instalación",
    select_user: "Selecciona un usuario",
    select_facility_category: "Selecciona una categoría de instalación",
    select_related_forms: "Selecciona formularios relacionados",
    prefill_template: "Es plantilla de pre-registro",
    requires_prefill: "Requiere pre-registro",
    is_mailable: "Se puede enviar por e-mail",
    display_in_alarm: "Mostrar en el menú de una alarma",
    is_horizontal: "Mostrar el formulario horizontalmente",
    is_cheker_maker: "Requiere aprobación",
    allow_draft: "Permitir guardar como borrador",
    types: {
      title: 'Tipo | Tipos',
      select: "Opción Múltiple",
      checkbox: "Casillas de validación",
      text_answer: "Respuesta de texto",
      files_section: "Archivos",
      commands: "Comandos",
      inputGroup: "Grupo de inputs",
      inputText: "Input de texto",
      users: "Usuario",
      rh_users: "Usuarios RH",
      units: "Instalaciones",
      facilities: "Instalación",
      placeholder: "Placeholder",
      facility_category: "Categoría de instalación",
      date: "Fecha",
      time: "Hora",
      minutes: "Minutos",
      time_hhmm: "Hora (HH:MM)",
      duration_hm: "Duración (horas y minutos)",
      duration_ms: "Duración (minutos y segundos)",
      duration_hms: "Duración (horas, minutos y segundos)",
      numeric: "Numérico",
      classification: "Clasificación",
      distribution_lists: "Listas de distribución",
      recipient: "Destinatario",
      subject: "Asunto",
      email: "Correo electrónico",
      related_forms: "Formularios relacionados",
      local_time: "Hora local",
      central_time: "Hora central",
      user_list: "Lista de usuarios",
      keyword: "Palabra clave",
      folio: "Folio",
      region: "Región",
      timestamp: "Marca de tiempo",
      device_doc: "Documentación de dispositivos",
      supplier: "Proveedor",
      technicians: "Técnicos",
    },
    allow_comment: "Permitir comentario",
    select_multiple: "Seleccionar múltiples",
    selecting_multiple: "Seleccionando...",
    clean: "Limpiar",
    send_to_review: "Enviar a revisión",
    reopen: "Reabrir formulario",
    state: "Estado",
    user: "Usuario",
    user_group: "Grupo de usuarios",
    date: "Fecha",
    note: "Nota",
    empty: "Sin movimientos",
    show_less: "Ver menos",
    show_all: "Ver todo el historial",
    btn_reassign: "Reasignar",
    close: "Cerrar",
    entries: "Entradas",
    history: "Historial",
    select_reviewer: "Selecciona usuario revisor",
    cannot_start_form: "No se pudo iniciar el formulario",
    update_state_error: "No se pudo actualizar el estado",
    answers_saved: "Respuestas guardadas",
    reassign: "Reasignar",
    select_reassigner: "Selecciona usuario para reasignar",
    assigned_to: "Asignar responsable",
    assigned_to_reopen: "Asignar responsable de reapertura",
    reassigned_to: "Reasignar responsable",
    review_comments: "Comentarios de la revisión",
    content: "Contenido",
    placeholder_tooltip: "serán reemplazados por valores reales cuando se envíen.",
    generate_keyword: "Generar palabra clave",
    maxlength: "Número máximo de caracteres",
    maxlengthSelect: "Número máximo de elementos que se pueden seleccionar",
    hint: "Texto de ayuda",
    date_format: "Formato de fecha",
    generate_timestamp: "Da click para generar marca de tiempo",
    check_facility_fields: "Marque qué campos adicionales deben aparecer",
    categories: "Categorías",
    subregion: "Subregión",
    id_seproban: "ID SEPROBAN",
    municipality: "Municipio",
    region_field: "Estado",
    sirh: "SIRH",
    rems: "REMS",
    read_only: "Solo lectura",
    maximun_amount: "Cantidad máxima que puede seleccionar",
    type_number: "Tipo número",
    no_extra_config: "No hay configuración adicional para este tipo de campo",
    lat: "Latitud",
    lng: "Longitud",
    read_only_users: "Usuarios de solo lectura",
    only_img: "Solo imagenes",
    show_empty: "Motrar vacio",
    read_only_users: "Usuarios de solo lectura",
    significant_event: "Evento Relevante",
    significant_event_title: "Titulo del evento",
    significant_event_description: "Descripción del evento",
    significant_event_regional_manager: "Director de seguridad encargado",
    security_manager: "Director de seguridad física",
    excluded_atms: "Exclude ATMs",
  }
}
